import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Toggles } from './toggles.model';
import { PayloadTypeEnum, VerifyAccountStateEnum } from '../features-data.data';

export const FEATURES_SCHEMA = Object.freeze({
  TOGGLES: Toggles,
  PAYLOADS: {},
});

const RECORD = generateSchema(FEATURES_SCHEMA);
const KEYS: any = generateKeys(FEATURES_SCHEMA);

export class Features extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOGGLES,
        value: new Toggles(this.toggles),
      },
    ]);

    return selfModel as Features;
  }

  get toggles(): Toggles {
    return this.get(KEYS.TOGGLES);
  }

  get payloads(): any {
    return this.get(KEYS.PAYLOADS);
  }
}
